var pageEvents = ['appear', 'disappear'];
var count = 0;
var getRandomId = function () { return ('sub' + (++count)); }
var noop = function() {}

module.exports = {
  message: 'subscribe',
  mapper: function(ref) {
    var action = ref.action;
    var handle = ref.handle; if ( handle === void 0 ) handle = noop;
    var success = ref.success; if ( success === void 0 ) success = noop;
    var fail = ref.fail; if ( fail === void 0 ) fail = noop;


    this._eventQueue = this._eventQueue || {};
    this._subscriptionMap = this._subscriptionMap || {};
    var subId = getRandomId();

    this._subscriptionMap[subId] = {action: action, handle: handle};

    var _events = this._eventQueue;
    var eventName = action;

    var eventHandler = function(e) {
      (_events[eventName] || []).filter(Boolean).forEach(function (fn) { return fn(e); });
    };

    function registerPageEvents() {
      if (!eventName) return;
      var capital = function (str) { return str.slice(0,1).toUpperCase() + str.slice(1); };
      if (window.DPApp) window.DPApp['on' + capital(eventName)] = eventHandler;
      success({subId: subId});
    }

    if (_events[eventName]) {
      //事件只需要向客户端注册一次，事件队列有JS段维护
      success({subId: subId});
      _events[eventName].push(handle);
      return;
    }

    _events[eventName] = [handle];

    //页面级别事件 appear/disappear 直接注册在DPApp全局对象下，事件触发时客户端会直接调用
    if (pageEvents.indexOf(eventName) !== -1) return registerPageEvents()
    return {
      action: eventName,
      success: function () { return success({subId: subId}); },
      handle: eventHandler,
      fail: fail
    };
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/titans/api/subscribe.js
// module id = 527
// module chunks = 0